export default "__VITE_ASSET__9ae4b628__"